module.exports = __webpack_public_path__ + "static/media/mistletoe.352ff758.svg";